import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M9 .492a8.508 8.508 0 1 0 0 17.016A8.508 8.508 0 0 0 9 .492M1.992 9a7.008 7.008 0 1 1 14.016 0A7.008 7.008 0 0 1 1.992 9M9 13.63a1.048 1.048 0 1 1 0-2.098 1.048 1.048 0 0 1 0 2.097M7.661 7.21A1.339 1.339 0 1 1 9 8.548a.75.75 0 0 0-.75.75v1.194a.75.75 0 0 0 1.5 0v-.544A2.84 2.84 0 1 0 6.161 7.21a.75.75 0 0 0 1.5 0",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h18v18H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }